import { PopupType, usePopupNotifications } from "@/composables";
import { useItemsNeedingAttentionCountStore, useOldMarketplaceItemsDialog } from "@/composables/portfolio";
import { createDashboardLink, router } from "@/router";
import { clearAfterAuthRedirect, getAfterAuthRedirect } from "@/services/afterAuthRedirectService";
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

type Redirect = string | RouteLocationAsPathGeneric | RouteLocationAsRelativeGeneric | undefined;

export const afterLogin = async (): Promise<void> => {
  return Promise.all([
    redirectAfterLogin(), //
    loadItemNeedingAttentionCount().then(openOldMarketplaceItemsPopupIfNeeded),
  ]).then(() => {}); // return void
};

const redirectAfterLogin = async (): Promise<Redirect> => {
  let redirect;

  const pendingRedirect = await getAfterAuthRedirect();
  if (pendingRedirect !== undefined) {
    clearAfterAuthRedirect();
    redirect = pendingRedirect;
  } else {
    const route = router.currentRoute.value;
    const queryRedirect = route.query.redirect_url;
    const isValidRedirect = typeof queryRedirect === "string";
    if (route.name === undefined) {
      return undefined; // First load
    } else if (isValidRedirect) {
      redirect = queryRedirect;
    } else if (route.meta.redirectWhenLoggedIn) {
      redirect = route.meta.redirectWhenLoggedIn;
    } else if (route.meta.public) {
      return undefined;
    } else {
      redirect = createDashboardLink();
    }
  }

  if (redirect !== undefined) {
    router.push(redirect);
  }
};

const loadItemNeedingAttentionCount = async () => {
  return useItemsNeedingAttentionCountStore().fetchCount();
};

const openOldMarketplaceItemsPopupIfNeeded = async () => {
  const count = useItemsNeedingAttentionCountStore().count.value;
  const isDialogOpeningAllowed = await useOldMarketplaceItemsDialog().isOpeningAllowed();
  if (count > 0 && isDialogOpeningAllowed) {
    usePopupNotifications().show(PopupType.HavingOldMarketplaceItems);
  }
};
